import { useContext, useEffect, useState } from "react";
import { FaRegTrashCan } from "react-icons/fa6";
import Nav from "../component/Nav";
import Footer from "../component/Footer";
import UserContext from "../context/UserContext";
import { PaystackButton } from "react-paystack";
import CartContext from "../context/CartContext";

export default function CartPage() {
  const { user, } = useContext(UserContext);
  const { setProd } = useContext(CartContext);
  const [cart, setCart] = useState(JSON.parse(localStorage.getItem("cart")));
  const [total, setTotal] = useState(0);
  const [country, setCountry] = useState();
  const [state, setState] = useState();
  const [city, setCity] = useState();
  const [streat, setStreat] = useState();
  const [postalCode, setPostalCode] = useState();
  const [message, setMessage] = useState();
  const publicKey = process.env.REACT_APP_PAYSTACK_PK;

  const metadata = {
    name: user?.name,
    phone: user?.phone,
    email: user?.email,
    userId: user?._id,
    location: JSON.stringify({
      state,
      city,
      country,
      streat,
      postalCode,
    }),
    products: cart ? JSON.stringify([...cart]): [],
    total,
  };

  const componentProps = {
    email: user?.email,
    amount: total * 100,
    metadata,
    publicKey,
    text: "Pay Now",
    onSuccess: () =>
      setMessage("Thanks for doing business with us! Come back soon!!"),
    onClose: () => alert("Wait! You need this oil, don't go!!!!"),
  };

  useEffect(() => {
    setCity(user?.address[0]?.city);
    setCountry(user?.address[0]?.country);
    setState(user?.address[0]?.state);
    setStreat(user?.address[0]?.street);
    setPostalCode(user?.address[0]?.postalCode);
  }, [user]);

  
  const increase = (id, amount) => {
    const items = JSON.parse(localStorage.getItem("cart"));
    for (let i = 0; i < items.length; i++) {
      const element = items[i];
      if (element._id === id._id) {
        element.num += 1;
      }
    }
    setProd(items)
    setCart(items);
    localStorage.setItem("cart", JSON.stringify(items));
  };

  const decrease = (id, amount) => {
    const items = JSON.parse(localStorage.getItem("cart"));
    for (let i = 0; i < items.length; i++) {
      const element = items[i];
      if (element._id === id._id && element.num !== 1) {
        element.num -= 1;
      }
    }
    setProd(items)
    setCart(items);
    localStorage.setItem("cart", JSON.stringify(items));
  };

  const removeItem = (id) => {
    const item = JSON.parse(localStorage.getItem("cart"));
    const newItems = item.filter((value) => value._id !== id._id);
    setCart(newItems);
    setProd(newItems)
    localStorage.setItem("cart", JSON.stringify(newItems));
  };

  useEffect(() => {
    let sum = 0;
    const items = JSON.parse(localStorage.getItem("cart"));

    for (let i = 0; i < items?.length; i++) {
      const element = items[i];
      sum += element?.price * element?.num;
    }
    setTotal(sum);
  }, [localStorage, cart]);

  return (
    <>
      <Nav />
      <br />
      <br />
      <br />
      <div className="cart-page">
        <h1 className="cart-title">Your Cart</h1>
        <div className="cart-wrapper">
          <div className="cart-items">
            {!cart ? (
              <p className="empty">Your cart is empty.</p>
            ) : (
              cart?.map((item) => (
                <div className="cart-item" key={item?._id}>
                  <img src={item?.images[0]} alt={item.name} />

                  <div className="item-info">
                    <section>
                      <h2>{item?.name}</h2>
                      <p className="price">${item.price * item.num}</p>
                    </section>
                    <section>
                      <div className="quantity-controls">
                        <button onClick={() => decrease(item, -1)}>-</button>
                        <span>{item.num}</span>
                        <button onClick={() => increase(item, 1)}>+</button>
                      </div>
                      <button
                        className="remove"
                        onClick={() => removeItem(item)}
                      >
                        <FaRegTrashCan size={25} />
                      </button>
                    </section>
                  </div>
                </div>
              ))
            )}
            <br />
            <h3 style={{ textAlign: "center" }}>Delivery Address</h3>
            <br />
            <div className="cart-address">
              <section>
                <label>Country</label>
                <input
                  type="text"
                  value={country}
                  onChange={(e) => setCountry(e.target.value)}
                  placeholder="Enter Country"
                />
              </section>
              <section>
                <label>State</label>
                <input
                  type="text"
                  value={state}
                  onChange={(e) => setState(e.target.value)}
                  placeholder="Enter State"
                />
              </section>
              <section>
                <label>City</label>
                <input
                  type="text"
                  value={city}
                  onChange={(e) => setCity(e.target.value)}
                  placeholder="Enter City"
                />
              </section>
              <section>
                <label>Streat Address</label>
                <input
                  type="text"
                  value={streat}
                  onChange={(e) => setStreat(e.target.value)}
                  placeholder="Enter Streat Address"
                />
              </section>
              <section>
                <label>Postal Code</label>
                <input
                  type="text"
                  value={postalCode}
                  onChange={(e) => setPostalCode(e.target.value)}
                  placeholder="Enter Postal Code"
                />
              </section>
            </div>
          </div>
          <div className="cart-summary">
            <h2>Order Summary</h2>
            <div className="summary-row">
              <span>Subtotal</span>
              <span>${total?.toFixed(2)}</span>
            </div>

            <PaystackButton {...componentProps} className="checkout-btn" />
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
